"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import { Boxes, Plus } from "lucide-react";
import { Button } from "../../ui/button";

interface BAPBPhysicalVerificationProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
}

export default function BAPBPhysicalVerification({ onBack, setActiveSection }: BAPBPhysicalVerificationProps) {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold text-white">Physical Verification – Biological Assets other than Bearer Plants</h2>
          <p className="text-sm text-white/60">Physical verification procedures for biological assets</p>
        </div>
      </div>
      <Card className="border-white/10 bg-white/5 text-white">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-lg">
            <Boxes className="h-5 w-5 text-amber-400" />
            Physical Verification
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-white/80">
            Document our procedures performed to physically verify the biological assets of the entity.
          </p>
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="border-white/20 text-white hover:bg-white/10"
          >
            <Plus className="h-4 w-4 mr-2" />
            Add
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
